import { NgModule } from 'angular-ts-decorators';
import { moduleName } from '../constants';

import { HeroCustomizerV3FilterCheckboxComponent } from './filter-checkbox/hero-customizer-v3-filter-checkbox.component';
import { HeroCustomizerV3FilterColorComponent } from './filter-color/hero-customizer-v3-filter-color.component';
import { HeroCustomizerV3FilterRadioComponent } from './filter-radio/hero-customizer-v3-filter-radio.component';
import { HeroCustomizerV3FiltersComponent } from './filters/hero-customizer-v3-filters.component';

import { OnlyVisibleOptionsPipe } from './only-visible-options.pipe';

@NgModule({
  declarations: [
    HeroCustomizerV3FilterCheckboxComponent,
    HeroCustomizerV3FilterColorComponent,
    HeroCustomizerV3FilterRadioComponent,
    HeroCustomizerV3FiltersComponent,

    OnlyVisibleOptionsPipe,
  ],
  id: `${moduleName}.filtering`,
  providers: [],
})
export class HeroCustomizerV3FilteringModule {
}
